module.exports = __webpack_public_path__ + "static/media/PMC-logo.ec4d4301.png";